<template>
<div class="diy-blank" :style="'height:'+itemStyle.height+'px; background: '+itemStyle.background">
</div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle"],
  created(){
  },
  activated() {
  },
  methods:{
    
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");

</style>